import { render } from "./AudienceExpansion.vue?vue&type=template&id=101bd697&scoped=true"
import script from "./AudienceExpansion.vue?vue&type=script&lang=js"
export * from "./AudienceExpansion.vue?vue&type=script&lang=js"

import "./AudienceExpansion.vue?vue&type=style&index=0&id=101bd697&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-101bd697"]])

export default __exports__